import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { CircularProgress } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import VerificationProfile from '../VerificationProfile'
import VendorProfile from '../../vendor-profile'
import { getVendorCompany } from '../../vendor.service'
import { VendorStatus } from '../../vendor.types'
import VendorProfileLayout from '../../vendor-profile-layout'

import styles from './VerificationWrapper.module.scss'

const VerificationWrapper: React.FC = () => {
  const { vendorId } = useParams()
  const dispatch = useAppDispatch()
  const { palette } = useTheme()
  const { vendor } = useAppSelector((state) => state.vendor)
  const navigate = useNavigate()

  useEffect(() => {
    if (vendorId) {
      void dispatch(getVendorCompany({ vendorId }))
    }
  }, [vendorId])

  useEffect(() => {
    if (vendor?.status === VendorStatus.rejected) {
      navigate('/lista', { replace: true })
    }
  }, [vendor])

  return vendor && vendor.id === vendorId ? (
    <>
      {(vendor.status === VendorStatus.pendingVerification ||
        vendor.status === VendorStatus.activated ||
        vendor.status === VendorStatus.additional_documents ||
        vendor.status === VendorStatus.pending_documents) && <VerificationProfile />}
      {vendor.status === VendorStatus.verified && (
        <VendorProfileLayout>
          <VendorProfile />
        </VendorProfileLayout>
      )}
    </>
  ) : (
    <div className={styles.loader}>
      <CircularProgress
        size={35}
        sx={{ marginLeft: '4px', color: palette.white.main, alignSelf: 'center' }}
      />
    </div>
  )
}

export default VerificationWrapper
